import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMdiLinkedin = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 29 29"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="transparent" d="M.5.5h28v28H.5z" />
    <path
      fill="currentColor"
      d="M22.667 4A2.333 2.333 0 0 1 25 6.333v16.334A2.333 2.333 0 0 1 22.667 25H6.333A2.333 2.333 0 0 1 4 22.667V6.333A2.333 2.333 0 0 1 6.333 4zm-.584 18.083V15.9a3.804 3.804 0 0 0-3.803-3.803c-.992 0-2.147.606-2.707 1.516v-1.295h-3.255v9.765h3.255v-5.751c0-.899.724-1.634 1.622-1.634a1.633 1.633 0 0 1 1.633 1.634v5.751zM8.527 10.487a1.96 1.96 0 0 0 1.96-1.96 1.967 1.967 0 0 0-1.96-1.972 1.97 1.97 0 0 0-1.972 1.972c0 1.085.887 1.96 1.972 1.96m1.621 11.596v-9.765H6.917v9.765z"
    />
  </svg>
);
export default SvgMdiLinkedin;
